import React from 'react';
import { RootPropsContext } from './root-props-context';

type RootProps = React.ContextType<typeof RootPropsContext>;

export const withRootProps = <P,>(WrappedComponent: React.ComponentType<P>) => {
  const WithRootProps = (props: P) => (
    <RootPropsContext.Provider value={props as P & RootProps}>
      <WrappedComponent {...(props as P & React.JSX.IntrinsicAttributes)} />
    </RootPropsContext.Provider>
  );

  return WithRootProps;
};
